import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { generalMessages } from 'constants/messages';

import './vendorRisk.scss';
import { translate } from 'utils/index';

const VendorRisk = ({ value }) => {
  const className = classNames(
    'recent-page-vendors-vendor-risk',
    `recent-page-vendors-vendor-risk--${value}`,
  );

  const riskValue = useMemo(() => {
    const formattedValue = value?.toLowerCase();

    if (formattedValue === 'low') {
      return translate(generalMessages.lowRisk);
    }

    if (formattedValue === 'medium') {
      return translate(generalMessages.mediumRisk);
    }

    if (formattedValue === 'high') {
      return translate(generalMessages.highRisk);
    }

    return value;
  }, [value]);

  return <div className={className}>{riskValue}</div>;
};

VendorRisk.propTypes = {
  value: PropTypes.string,
};

export default VendorRisk;
